module.exports = "<label class=\"btn\"\n  v-class=\"active:checked,\n  btn-success:type == 'success',\n  btn-warning:type == 'warning',\n  btn-info:type == 'info',\n  btn-danger:type == 'danger',\n  btn-default:type == 'default',\n  btn-primary:type == 'primary',\n  \">\n\n    <input type=\"checkbox\" autocomplete=\"off\"\n    checked=\"{{checked}}\"\n    v-on=\"click:handleClick\">\n\n    <content></content>\n\n  </label>";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/checkboxBtn.vue
 ** module id = 97
 ** module chunks = 0
 **/